import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { hotGossipArticles } from '@/mocks/homeData';

export default function HotGossipSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScroll, { passive: true });
      checkScroll();
      return () => el.removeEventListener('scroll', checkScroll);
    }
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = 340;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              热门<span className="text-accent-500">爆料</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              最新最热的黑料爆料，第一时间掌握
            </p>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-200 cursor-pointer ${
                canScrollLeft
                  ? 'border-foreground-300 text-foreground-700 hover:bg-foreground-100'
                  : 'border-foreground-200 text-foreground-300 cursor-not-allowed'
              }`}
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-200 cursor-pointer ${
                canScrollRight
                  ? 'border-foreground-300 text-foreground-700 hover:bg-foreground-100'
                  : 'border-foreground-200 text-foreground-300 cursor-not-allowed'
              }`}
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div className="relative">
          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-4 -mr-4 md:-mr-6 snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {hotGossipArticles.map((article) => (
              <Link
                key={article.id}
                to="/"
                className="flex-shrink-0 w-[280px] md:w-[320px] snap-start group cursor-pointer"
              >
                <div className="rounded-lg overflow-hidden bg-background-50 border border-foreground-200/40 transition-all duration-300 group-hover:border-accent-300/60">
                  <div className="relative h-[200px] md:h-[220px] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-label text-foreground-700">
                      {article.category}
                    </span>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-accent-600 transition-colors duration-200">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-3 line-clamp-1">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-foreground-600 font-label font-medium">
                        <i className="ri-eye-line mr-1"></i>
                        {(article.views / 10000).toFixed(1)}万
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}